import { Navigate, Outlet } from 'react-router';
import embeddedAppUtils from 'utils/embeddedAppUtils';
import storageService, { Locals } from '../../utils/storageService';

const RouteGuard = () => {
    if (embeddedAppUtils.isAppEmbedded()) {
        return <Outlet />;
    }
    const isAuthenticated = !!storageService.getItem(Locals.ACCESS_TOKEN);
    return isAuthenticated ? <Outlet /> : <Navigate to={'/login-landing'} replace />; // or loading indicator, etc...
};

export default RouteGuard;
